import {BackendService} from "./backend.service";
import {RequestAnfrage} from "../model/request.anfrage";
import {PortalService} from "./portal.service";
import {EmbedService} from "./embed.service";

export abstract class RequestService {

  /**
   * the current requestObject.
   * @protected
   */
  protected anfrage: RequestAnfrage;

  /**
   * Name of the request object in the local storage.
   * @protected
   */
  protected abstract requestObjectName: string;

  /**
   * Number of days that the localstoragedata is "valid", will be used for existing requests.
   * @private
   */
  private readonly LOCALSTORAGE_TIMEOUT_DAYS = 2;

  /**
   * constructor.
   * @param backendService
   * @param portalService
   * @param embedService
   * @protected
   */
  protected constructor(protected backendService: BackendService, protected portalService: PortalService,
                        protected embedService: EmbedService) {}

  /**
   * Will return a new, empty requestobject for the current advisor.
   * Must be implemented by child classes.
   */
  abstract getNewAnfrage(): RequestAnfrage;

  /**
   * try to load the data from local storage.
   */
  loadDataFromLocalStorage(): void {
    console.log("Load Data from LocalStorage", this.requestObjectName);
    try {
      if (typeof localStorage === "object") {
        // load anfrage
        const localAnfrage = localStorage.getItem(this.requestObjectName);
        if (localAnfrage !== null) {
          // parse the stored data
          const deserializedData: RequestAnfrage = JSON.parse(localAnfrage);
          if (deserializedData) {
            // check if the data is still valid
            if (deserializedData.lastupdate) {
              const diffDays = ((new Date()).getTime() - deserializedData.lastupdate) / 1000 / 60 / 60 / 24;
              if (diffDays > this.LOCALSTORAGE_TIMEOUT_DAYS) {
                this.resetLocalStorage();
                // remove requestId
                this.backendService.resetRequestId();

                // stop the initialiszation here.
                return;
              }
            }

            // create an empty object and set all data that we got from the local storage on it
            this.anfrage = this.getNewAnfrage();
            Object.keys(this.anfrage).map(key => {
              if (deserializedData.hasOwnProperty(key)) {
                this.anfrage[key] = deserializedData[key];
              }
            });
          }
        }
      }
    }
    catch (e) {
      return;
    }
  }

  /**
   * Returns the users input object.
   */
  getAnfrage(): RequestAnfrage {
    return this.anfrage ? this.anfrage : this.getNewAnfrage();
  }

  /**
   * sets the anfrage with (new) data
   * @param anfrage
   * @param saveToServer
   */
  setAnfrage(anfrage: RequestAnfrage, saveToServer: boolean = false) {
    this.anfrage = anfrage;
    this.anfrage.portalId = this.portalService.currentPortalId;
    this.anfrage.campaignId = this.embedService.getCampaignId();
    this.saveDataToLocalStorage();

    if(saveToServer === true) {
      this.saveDataToServer();
    }
  }

  /**
   * Save the data to the local storage.
   */
  saveDataToLocalStorage(): void {
    try {
      if(typeof localStorage === "object") {
        // set update date
        this.anfrage.lastupdate = new Date().getTime();
        // save anfrage
        localStorage.setItem(this.requestObjectName, JSON.stringify(this.anfrage));
      }
    }
    catch (e) {
      return;
    }
  }

  /**
   * sabves the current data to the backend
   */
  saveDataToServer(): void {
    this.backendService.saveData(this.anfrage);
  }

  /**
   * Resets the data in the local storage.
   * Can be used to avoid overwritung of existing data in the backend. i.e. if the requestId has changed.
   */
  resetLocalStorage(): void {
    try {
      if(typeof localStorage === "object") {
        // save anfrage
        localStorage.removeItem(this.requestObjectName);
      }
    }
    catch (e) {
      return;
    }
    this.anfrage = this.getNewAnfrage();
  }
}
